"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zdyPage = require("@/api/zdyPage");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ZdyDraggingIndex',
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        name: undefined,
        enable: undefined
      },
      selectedItems: [],
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        name: '',
        type: 1,
        pageIndex: '',
        json: '',
        enable: true,
        urlLink: '',
        backgroundColor: '#ffffff'
      },
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        pageIndex: [{
          required: true,
          message: '请输入页面标识',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  filters: {
    parseTime: _index.parseTime
  },
  methods: {
    // 获取列表数据
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _zdyPage.getXyZdyDraggingPage)(this.listQuery).then(function (response) {
        _this.list = response.records || [];
        _this.total = response.total || 0;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
        _this.$message.error('获取数据失败');
      });
    },
    // 搜索
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 新增
    handleCreate: function handleCreate() {
      // 在新窗口/标签页中打开独立页面进行配置
      this.$router.push({
        path: '/zdy-dragging/configPage',
        query: {
          id: null
        }
      });
    },
    // 编辑
    handleUpdate: function handleUpdate(row) {
      // 在新窗口/标签页中打开独立页面进行配置
      this.$router.push({
        path: '/zdy-dragging/configPage',
        query: {
          id: row.id
        }
      });
    },
    // 复制：以源数据打开装修页，但不带 id（保存即新建一条）
    handleCopy: function handleCopy(row) {
      this.$router.push({
        path: '/zdy-dragging/configPage',
        query: {
          copyFrom: row.id
        }
      });
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _zdyPage.deleteXyZdyDragging)(row.id).then(function () {
          _this2.$message.success('删除成功');
          _this2.getList();
        }).catch(function () {
          _this2.$message.error('删除失败');
        });
      }).catch(function () {
        _this2.$message.info('已取消删除');
      });
    },
    // 状态变更
    handleStatusChange: function handleStatusChange(row) {
      var _this3 = this;
      var param = {
        id: row.id,
        enable: row.enable
      };
      (0, _zdyPage.updateStatus)(param).then(function () {
        _this3.$message.success("\u72B6\u6001\u5DF2\u66F4\u65B0\u4E3A".concat(row.enable ? '启用' : '禁用'));
      }).catch(function () {
        // 操作失败时恢复原状态
        row.enable = !row.enable;
        _this3.$message.error('状态更新失败');
      });
    },
    // 复制链接地址
    copyUrl: function copyUrl(url) {
      var _this4 = this;
      if (!url) return;

      // 优先使用现代 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(function () {
          _this4.$message.success('链接已复制到剪贴板');
        }).catch(function () {
          _this4.$message.error('复制失败');
        });
      } else {
        // 降级方案：使用传统方法
        var textarea = document.createElement('textarea');
        textarea.value = url;
        document.body.appendChild(textarea);
        textarea.select();
        try {
          var successful = document.execCommand('copy');
          if (successful) {
            this.$message.success('链接已复制到剪贴板');
          } else {
            this.$message.error('复制失败');
          }
        } catch (err) {
          this.$message.error('复制失败');
        }
        document.body.removeChild(textarea);
      }
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    }
  }
};